import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { useSettings } from "@/context/SettingsContext";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
};

export const siteOrigin = (settings) => {
  const w = (settings.website || "").trim().replace(/\/$/, "");
  return w ? (w.startsWith("http") ? w : `https://${w}`) : window.location.origin;
};

export const Seo = ({ page, title, description, image, noindex = false, jsonLd }) => {
  const { t, lang } = useLanguage();
  const { settings } = useSettings();
  const { pathname } = useLocation();
  useEffect(() => {
    const meta = t.seo[page] || t.seo.home;
    const fullTitle = `${title || meta.title} | ${settings.company_name}`;
    const desc = description || meta.description;
    const origin = siteOrigin(settings);
    const url = `${origin}${pathname}`;
    document.title = fullTitle;
    document.documentElement.lang = lang;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", lang === "fr" ? "fr_CI" : "en_US");
    setMeta("property", "og:site_name", settings.company_name);
    setMeta("property", "og:image", image || `${origin}/logos/logo_full.png`);
    setMeta("name", "twitter:card", "summary_large_image");
    setLink("canonical", url);
    let script = document.getElementById("seo-jsonld");
    if (!script) { script = document.createElement("script"); script.id = "seo-jsonld"; script.type = "application/ld+json"; document.head.appendChild(script); }
    script.textContent = JSON.stringify(jsonLd || {
      "@context": "https://schema.org", "@type": "AutoRepair", name: settings.company_name, url: origin,
      image: `${origin}/logos/logo_full.png`, telephone: settings.phone, email: settings.email,
      address: { "@type": "PostalAddress", streetAddress: settings.address, addressLocality: "Abidjan", addressCountry: "CI" },
      areaServed: "Abidjan", priceRange: "$$", openingHours: "Mo-Sa 08:00-18:00",
      sameAs: [...Object.values(settings.social || {}), ...(settings.social_links || []).map((l) => l.url)].filter(Boolean),
    });
  }, [page, title, description, image, noindex, jsonLd, t, lang, settings, pathname]);
  return null;
};
